import { render, staticRenderFns } from "./id-column.vue?vue&type=template&id=1dc06763&"
import script from "./id-column.vue?vue&type=script&lang=ts&"
export * from "./id-column.vue?vue&type=script&lang=ts&"
import style0 from "./id-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports